import { useBranch } from "@/context/BranchContext";
import { Building2 } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function BranchGate() {
  const { branches, setBranch } = useBranch();
  return (
    <div className="min-h-[70vh] flex items-center justify-center p-6" data-testid="branch-gate">
      <div className="w-full max-w-md text-center space-y-7">
        <div className="w-14 h-14 rounded-2xl bg-forest/10 flex items-center justify-center mx-auto">
          <Building2 className="h-7 w-7 text-forest" />
        </div>
        <div>
          <h2 className="font-heading text-3xl font-bold text-forest">Select your branch</h2>
          <p className="text-sage mt-2 text-sm">
            Choose a location to work in. Your session locks to this branch to keep the day&apos;s data clean and separate.
          </p>
        </div>
        <div className="grid gap-3">
          {branches.map((b) => (
            <Button
              key={b.id}
              variant="outline"
              className="h-14 justify-start text-base border-2 hover:border-forest hover:bg-forest/5"
              onClick={() => setBranch(b.id)}
              data-testid={`branch-gate-${b.id}`}
            >
              <Building2 className="h-5 w-5 mr-3 text-forest" />
              {b.name}
            </Button>
          ))}
        </div>
      </div>
    </div>
  );
}
